import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close.svg'
import _imports_1 from '@/assets/arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-173a4390"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "chat-dialog-container"
}
const _hoisted_2 = { class: "chat-dialog" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"flex-end","padding":"10px"} }
const _hoisted_4 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-around","height":"550px","word-break":"normal"} }
const _hoisted_5 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"1rem"} }, "Customer Chat History", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "No chat history with this customer")
], -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  style: {"margin":"1rem 2rem","text-align":"left","width":"60%"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "SMS to Jane at 123-456-7890")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "We noticed a suspicious transaction. Is it yours?")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "Jane to Chatbot:")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "Yes")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "SMS to Jane at 123-456-7890")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "We need more information, please tell us the purpose of this transaction and how you know the recipient.")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "Jane to Chatbot:")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"background":"#e8ebf5","padding":"1px 10px","font-size":".8em","margin-bottom":"3px"} }, [
  /*#__PURE__*/_createElementVNode("li", null, "I met Charlie online, and he is very nice. He has a good investment opportunity for me. ")
], -1))
const _hoisted_19 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Agent Data Entry", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Analyze", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"30px","margin-left":"10px"},
  alt: ""
}, null, -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { style: {"margin":"1rem 2rem","text-align":"left","display":"flex","flex-direction":"column","height":"625px","width":"450px"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"margin-bottom":"1rem"} }, "Analysis", -1))
const _hoisted_27 = {
  key: 0,
  style: {"flex":"1","font-size":".7em","overflow":"auto","word-break":"normal"}
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Decision: "),
  /*#__PURE__*/_createTextVNode("Scam")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Confidence: "),
  /*#__PURE__*/_createTextVNode("90%")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Rationale:")
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "The initial message raises suspicion by alerting Jane about a suspicious transaction without providing specific details or context. "),
  /*#__PURE__*/_createElementVNode("li", null, "Jane’s response about meeting someone named Charlie online and the investment opportunity is a common narrative used in scams. "),
  /*#__PURE__*/_createElementVNode("li", null, "Scammers often use personal connections and investment opportunities to deceive victims into providing money or sensitive information."),
  /*#__PURE__*/_createElementVNode("li", null, "The lack of specific information about the transaction or legitimate identifiers of the sender raises concerns. "),
  /*#__PURE__*/_createElementVNode("li", null, "Legitimate financial institutions or authorities would typically provide more information and guidance regarding suspicious transactions. ")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Recommendation"),
  /*#__PURE__*/_createTextVNode(" to Jane:")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Cease all communication with the sender and do not provide any further information or engage in any financial transactions. "),
  /*#__PURE__*/_createElementVNode("li", null, "Do not share personal information, bank details, or send money to anyone based on unsolicited messages or investment opportunities received online. "),
  /*#__PURE__*/_createElementVNode("li", null, "If you have already provided personal information or conducted any financial transactions, contact your bank or financial institution immediately to report the incident and seek guidance on protecting your accounts. "),
  /*#__PURE__*/_createElementVNode("li", null, "Report the suspicious conversation to your local law enforcement authorities, providing them with any available details. "),
  /*#__PURE__*/_createElementVNode("li", null, "Be cautious of future unsolicited messages, especially those related to investment opportunities or financial transactions. Research thoroughly and consult with trusted financial advisors before making any investment decisions. ")
], -1))
const _hoisted_34 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30,
  _hoisted_31,
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  id: "answer-transaction",
  style: {"overflow":"auto","height":"100%","flex":"1","word-break":"normal"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Send Report", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"30px","margin-left":"10px"},
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"space-around","align-items":"center","margin-right":"2rem"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"100px","cursor":"pointer","padding":"5px 10px","border":"1px solid black","border-radius":"10px","margin-right":"1rem","background":"#ed7d31","color":"white"} }, " Deny "),
  /*#__PURE__*/_createElementVNode("div", { style: {"width":"100px","cursor":"pointer","padding":"5px 10px","border":"1px solid black","border-radius":"10px","margin-right":"1rem","background":"green","color":"white"} }, " Allow")
], -1))

import { useAuth0 } from '@auth0/auth0-vue';
import axios from 'axios';
import { computed, getCurrentInstance, ref, watch } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionDialog',
  setup(__props) {

const { user } = useAuth0()

const text = ref('')

const store = useStore()

const transaction = computed({
    get: () => store.getters.currentTransaction,
    set: (value) => store.commit('SET_TRANSACTION', value)
})


const showDialog = computed({
    get: () => store.getters.showTransactionDialog,
    set: (value) => store.commit('SET_SHOW_TRANSACTION_DIALOG', value)
})

const loading = ref(false)


const messageSent = ref(false)

const send = async () => {

    messageSent.value = true

    const answer = document.getElementById("answer-transaction")
    const textarea = document.getElementById("input")


    loading.value = true
    answer!.innerHTML = "Loading..."
    answer!.classList.add("blink_me")
    let response: any = null

    const query = text.value

    console.log(query)

    try {
        
        response = await axios.post(`${process.env.VUE_APP_BACKEND_URI}/predict`, { text: query, email: user.value.email })

        answer!.classList.remove("blink_me")
        loading.value = false
        answer!.innerHTML = ""
        const speed = 20
        let lastChar = ""
        for (let i = 0; i < response.data.answer.length; i++) {
            setTimeout(() => {
                const char = response.data.answer.charAt(i)
                if (char == "\n")
                    answer!.innerHTML += "<br/>"
                else if (char == "-" && /\s/.test(lastChar))
                    answer!.innerHTML += "&#8226; "
                else if (char == "•" && /\s/.test(lastChar))
                    answer!.innerHTML += "&#8226; "
                else
                    answer!.innerHTML += response.data.answer.charAt(i)

                lastChar = char

            }, i * speed)
        }

    } catch (error) {
        answer!.classList.remove("blink_me")
        loading.value = false
        answer!.innerHTML = "Error..."
        textarea!.textContent = ""
    }
}

const showChat = () => {
    store.commit('SET_SHOW_TRANSACTION_DIALOG', false)

    setTimeout(() => {
        store.commit('SET_SHOW_CHAT_DIALOG', true)
    }, 300);

}

const sendReport = () => {
    store.commit('SET_SHOW_TRANSACTION_DIALOG', false)
    store.commit("SET_CURRENT_INPUT", text.value)

    setTimeout(() => {
        store.commit("SET_SHOW_DETAILED_REPORT_DIALOG", true)
        
    }, 300);
}


watch(showDialog, async (value) => {
    if (value === false) {
        text.value = ""
        messageSent.value = false
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, null, {
    default: _withCtx(() => [
      (showDialog.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "chat-background",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: _imports_0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false)),
                  style: {"cursor":"pointer","width":"38px"}
                })
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  (transaction.value.customer.fullname !== 'Jane Zimmer')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_19))
                ]),
                _createElementVNode("div", null, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("textarea", {
                    id: "input",
                    style: {"height":"100%","width":"350px","word-break":"normal"},
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((text).value = $event))
                  }, null, 512), [
                    [_vModelText, text.value]
                  ]),
                  _hoisted_21,
                  _createElementVNode("div", {
                    onClick: send,
                    style: {"margin-top":"1rem","display":"flex","width":"100%","cursor":"pointer","justify-content":"center"}
                  }, _hoisted_24)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  (transaction.value.customer.fullname === 'Jane Zimmer' && !messageSent.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_34))
                    : (_openBlock(), _createElementBlock("div", _hoisted_35)),
                  _createElementVNode("div", {
                    onClick: sendReport,
                    style: {"display":"flex","width":"100%","cursor":"pointer","justify-content":"center","margin-top":"1rem"}
                  }, _hoisted_38)
                ])
              ]),
              _hoisted_39,
              _createElementVNode("div", { style: {"display":"flex","flex-direction":"row","justify-content":"space-between","margin-top":"8rem"} }, [
                _createElementVNode("button", {
                  style: {"width":"100px","height":"37px","margin-left":"100px"},
                  class: "chatbot-button",
                  onClick: showChat
                }, "Chat"),
                _hoisted_40
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})